import { render, staticRenderFns } from "./DashboardCarouselCards.vue?vue&type=template&id=4dee980c&"
import script from "./DashboardCarouselCards.vue?vue&type=script&lang=js&"
export * from "./DashboardCarouselCards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCarouselCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports